import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/** Allineato al margine “approach” (~45% viewport) */
export const GSAP_SECTION_START = 'top 80%';

/**
 * ScrollTrigger + stato inView per TextEffects + reveal `.gsap-reveal`.
 * Pattern cleanup: ctx.revert() (solo i trigger di questa sezione)
 */
export default function useGsapSection(
  ref,
  {
    start = GSAP_SECTION_START,
    once = true,
    revealSelector = '.gsap-reveal',
    revealY = 28,
    setup,
  } = {},
) {
  const [inView, setInView] = useState(false);
  const setupRef = useRef(setup);
  setupRef.current = setup;

  useEffect(() => {
    const scope = ref.current;
    if (!scope) return undefined;

    const ctx = gsap.context(() => {
      const scrollOpts = { trigger: scope, start: 'top 80%', once };

      const inViewSt = ScrollTrigger.create({
        ...scrollOpts,
        onEnter: () => setInView(true),
        onEnterBack: () => setInView(true),
      });

      requestAnimationFrame(() => {
        if (inViewSt.isActive) setInView(true);
      });

      if (scope.querySelector(revealSelector)) {
        gsap.from(revealSelector, {
          opacity: 0,
          y: revealY,
          duration: 0.9,
          stagger: 0.08,
          ease: 'power3.out',
          scrollTrigger: scrollOpts,
        });
      }

      setupRef.current?.(gsap, scope, scrollOpts);
    }, scope);

    return () => {
      setInView(false);
      ctx.revert();
    };
  }, [ref, start, once, revealSelector, revealY]);

  return inView;
}
